import { createContext, ReactNode, useState } from "react";
import { ChatRequest } from "../../AI-Types";

export const ReviewContentContext = createContext({
    contentType: 'SalesPitch',
    chatRequest: {
        promptDetails: '',
        actions: []
    } as ChatRequest,
    setChatRequest: (value: ChatRequest) => { }
})

type Props = {
    children: ReactNode,
    initialPrompt: string,
    contentType: 'SalesPitch'
}

export const ReviewContentProvider = ({ children, initialPrompt, contentType }: Props) => {
    const [chatRequest, setChatRequest] = useState<ChatRequest>({
        promptDetails: initialPrompt,
        actions: []
    });

    return (
        <ReviewContentContext.Provider value={{ chatRequest, setChatRequest, contentType }}>
            {children}
        </ReviewContentContext.Provider>
    )
}